import { RouterModule, Routes } from '@angular/router';
import { sessionActiveGuard } from '@smartera/core';
import { PageComponent } from './page.component';

const pageRoutes: Routes = [
	{
		path: 'page',
		canMatch: [sessionActiveGuard],
		component: PageComponent,
		children: [
			{
				path: '',
				redirectTo: 'dashboard',
				pathMatch: 'full',
			},
			{
				path: 'dashboard',
				loadChildren: () => import('../multi-dashboard/multi-dashboard.module').then((m) => m.MultiDashboardModule),
			},
			{
				path: 'security',
				loadChildren: () => import('../../modules/security/security.module').then((m) => m.SecurityModule),
			},

			{
				path: 'smart-report',
				loadChildren: () => import('../smart-reports-core/smart-reports.module').then((m) => m.SmartReportsModule),
			},
			// {
			//   path: 'personal',
			//   component: PersonalComponent,
			// },
			{ path: '**', redirectTo: '/error/404' },
		],
	},
];

export const PageRoutingModule = RouterModule.forChild(pageRoutes);
